import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { AboutGeaComponent } from './about-gea/about-gea.component';

const routes: Routes = [
  {
    // Needed for hash routing
    path: 'error',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    // Needed for hash routing
    path: 'state',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    // Needed for hash routing
    path: 'code',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    // Needed for hash routing
    path: 'about-gea',
    component: AboutGeaComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
